export const logger = 'logger';
export const auth = 'auth';
export const authEdge = 'authedge'
export const manager = 'manager';
export const sequencer = 'sequencer';
export const media = 'media';
export const studentdata = 'studentdata';
export const portal = 'portal';
export const client = 'client';
export const support = 'support';
export const kvs = 'kvs';


// WEBPACK FOOTER //
// ./src/constants/apiServices.js